export type PreviewDevice = "phone" | "tablet" | "desktop";
export type PreviewView = "cover" | "invitation";

export const previewDevices: Record<PreviewDevice, { label: string; width: number; height: number; icon: string }> = {
  phone: { label: "Phone", width: 390, height: 844, icon: "▯" },
  tablet: { label: "Tablet", width: 768, height: 1024, icon: "▭" },
  desktop: { label: "Desktop", width: 1280, height: 800, icon: "▰" }
};

export const BUILDER_PREVIEW_MESSAGE = "invitedstudio:builder-preview";

export function calculateFitZoom(stageWidth: number, deviceWidth: number) {
  const horizontalSpace = Math.max(0, stageWidth - 48);
  const percentage = Math.floor((horizontalSpace / (deviceWidth + 14)) * 100);
  return Math.min(100, Math.max(30, percentage));
}
